import { FormCreator } from '../index';

const { Schema, TYPES } = FormCreator;

export default [
  new Schema(TYPES.TEXT, 'oldPassword', 'Current Password', undefined, {
    required: true,
    type: 'password',
    fullWidth: true,
  }),
  new Schema(TYPES.TEXT, 'newPassword', 'New Password', undefined, {
    required: true,
    type: 'password',
    fullWidth: true,
  }),
];
